import axios from "axios";
import { SaveButton, CancelButton } from "../../common/Buttons";
import PLAN_URL from "../../../utils/PLAN_URL";
import { useParams } from "react-router-dom";

const updateUrl = `${PLAN_URL}/api/material/update`;

export const CustomEditActionButtons = ({
  table,
  row,
  openSnackbar,
  newRow,
  setUpdateStatus,
}) => {
  const { group_code, project_code } = useParams();
  const handleCancel = () => {
    table.setEditingRow(null);
  };
  const handleSave = async () => {
    try {
      const payload = {
        group_code,
        project_code,
        ...newRow,
      };
      const res = await axios.put(updateUrl, payload);
      // await handleUpdateOrder({ values, table });
      if (res.status === 200) {
        openSnackbar("정상적으로 수정하였습니다.", "success");
      }
    } catch (e) {
      openSnackbar(`오류가 발생했습니다. ${e.message}`, "error");
    } finally {
      table.setEditingRow(null);
      setUpdateStatus((prev) => !prev);
    }
  };
  return (
    <div style={{ display: "flex", gap: "4px" }}>
      <SaveButton onClick={handleSave} />
      <CancelButton onClick={handleCancel} />
    </div>
  );
};

export default CustomEditActionButtons;
